/*global moment*/
(function (module) {
    module.filter('remainDays', function () {
        return function (date) {
            var current = moment();
            var end = moment(date);
            var days = end.diff(current, 'd');
            //0 count
            return days + 1;
        };
    });
}(angular.module('emarket.commons')));
